import { Device } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'


export interface UpdateShopDeviceInfoMutationResponse {
  updateShopDeviceInfo: Device
}

export interface UpdateShopDeviceInfoMutationVariables {
  newData: {
    id: GQL_ID
    shop_id: GQL_ID
  }
}

export const UPDATE_SHOP_DEVICE_INFO = gql`
  mutation updateShopDeviceInfo($newData: ShopDeviceInfoInput!) {
    updateShopDeviceInfo(newData: $newData) {
      id
      shop_id
    }
  }
`

export const useMutateUpdateShopDeviceInfo = () => useMutation<
  UpdateShopDeviceInfoMutationResponse,
  UpdateShopDeviceInfoMutationVariables
>(UPDATE_SHOP_DEVICE_INFO)